import isEmpty from 'lodash.isempty';
import { connect } from 'react-redux';
import config from '../../../configs/reading';
import { selectors } from '../../../root/reading/root';
import Header from '../../../features/header/Header';
import {
    getClassDropDownProps,
    getSchoolDropDownProps,
    getDistrictDropDownProps,
    getTopMenuItems,
    getPrintItemsWithHandler,
    getPageActiveClass,
} from '../../../utils/shared/headerUtils';
import { getUrlParams } from '../../../utils/shared/urlUtils';
import switchGrade from '../../../api/featureReport/featureReportActions';
import {
    clearCheckPoints,
    switchInstructionGrade,
} from '../../../api/instruction/shared/instructionActions';
import switchDualLanguageGrade from '../../../api/dualLanguage/dualLanguageActions';
import {
    fetchEnrollmentData,
    fetchAdditionalEnrollmentData as fetchAdditionalEnrollmentDataAction,
} from '../../../api/enrollment/reading/enrollmentActions';
import { clearResults } from '../../../api/results/shared/resultActions';
import { clearPercentileToggleState } from '../../../api/percentiles/percentilesActions';
import { clearR3DInterps } from '../../../api/interps/shared/interpActions';
import { generatePdf as generatePdfAction } from '../../../api/pdfGeneration/shared/pdfActions';
import { fetchAllStudentsEnrollmentInfo as fetchAllStudentsEnrollmentInfoAction } from '../../../api/studentSummary/reading/studentSummaryActions';
import getAdditionalURLParams from './HeaderHelper';
import { clearLexileToggleState } from '../../../api/lexile/lexileActions';
import buildHelpItems from '../../../utils/reading/helpUtils';
import { PERIOD } from '../../../constants/shared/CommonConstants';
import { fetchAllTroBooksData as fetchAllTroBooksDataAction } from '../../../api/troBooksData/troBooksDataActions';
import { uploadPdfAvailability as uploadPdfAvailabilityAction } from '../../../api/applicationConfig/shared/applicationConfigActions';
import ReadingApplicationConfigClient from '../../../api/clients/reading/ApplicationConfigClient';
import { fetchAdditionalStudentResults as fetchAdditionalStudentResultsAction } from '../../../api/results/reading/resultActions';
import {
    lrsPrintCurrentPageEvent,
    lrsSelectHelpItemEvent,
    selectedHeaderDropdownEvent,
} from '../../../api/lrs/shared/lrsActions';
import { HEADER_DROPDOWN_TYPES } from '../../../constants/shared/LrsConstants';
import { getAppLogo } from '../../../root/shared/rootHelpers';
import { setLrsSelectedHeaderDropdownProps } from '../../../features/lrs/shared/lrsHelpers';
import { clearAdditionalEnrollmentInfo } from '../../../api/enrollment/shared/enrollmentActions';
import { downloadDemoPdf } from '../../../api/demoMode/reading/demoModeActions';
import isStandaloneExpress from '../../../utils/reading/expressUtils';
import { BASE_URLS } from '../../../constants/reading/ApiConstants';

const { DISTRICT, SCHOOL, CLASS } = HEADER_DROPDOWN_TYPES;
const { INSTRUCTIONS_URL } = BASE_URLS;

const switchGrades = dispatch => {
    dispatch(switchGrade());
    dispatch(switchInstructionGrade());
    dispatch(switchDualLanguageGrade());
};

const clearState = (dispatch, r3dClearFlag = true) => {
    dispatch(clearResults());

    if (r3dClearFlag) {
        dispatch(clearR3DInterps());
    }

    dispatch(clearCheckPoints());
    dispatch(clearPercentileToggleState());
    dispatch(clearLexileToggleState());
    dispatch(clearAdditionalEnrollmentInfo());
};

const mapStateToProps = state => {
    const selectedPeriod = selectors.getSelectedPeriod(state);
    return {
        availablePrintItems: selectors.getAvailablePrintItems(state),
        selectedPeriod,
        licensingInfo: selectors.getLicensingInfo(state),
        chosenDistrictUid: selectors.getDistrictId(state),
        chosenSchoolUid: selectors.getSchoolId(state),
        districtDropDownProps: getDistrictDropDownProps(state),
        schoolDropDownProps: getSchoolDropDownProps(state),
        classDropDownProps: getClassDropDownProps(state),
        location: selectors.getLocation(state),
        areCheckPointsFetched: selectors.areCheckPointsFetched(state),
        studentIds: selectors.getStudentIds(state),
        isPrintIconDisabled:
            selectors.isPrintIconDisabled(state) || selectors.isAdditionalBooksDataFetching(state),
        views: config.views,
        appUrl: config.appUrl,
        officialTeacher: selectors.getClassOrGroupOfficialTeacher(state),
        isStaffConfigFetched: selectors.isStaffConfigFetched(state),
        isDemoModeOn: selectors.getIsDemoModeOn(state),
        hasError: selectors.hasErrorExcludingUnauthorized(state),
        demoClass: selectors.getDemoClass(state),
        isGuidedTourOn: selectors.getIsGuidedTourOn(state),
        selectedPeriodLabel:
            selectedPeriod === PERIOD.SUMMER
                ? selectors.getSummerPeriodLabel(state)
                : selectedPeriod,
    };
};

const mapDispatchToProps = dispatch => ({
    generatePdf: (pdfConfiguration, preCallback) =>
        dispatch(generatePdfAction(pdfConfiguration, preCallback)),
    lrsSelectHelpItem: title => dispatch(lrsSelectHelpItemEvent(title)),
    lrsPrintCurrentPage: ({ documentKey, pdfInHeader }) =>
        dispatch(lrsPrintCurrentPageEvent({ documentKey, pdfInHeader })),
    fetchAllStudentsEnrollmentInfo: (studentIds, successfulCallback, applicationSid) =>
        dispatch(
            fetchAllStudentsEnrollmentInfoAction(studentIds, successfulCallback, applicationSid),
        ),
    fetchAllTroBooksData: successfulCallback =>
        dispatch(fetchAllTroBooksDataAction(successfulCallback)),
    fetchAdditionalEnrollmentData: () => dispatch(fetchAdditionalEnrollmentDataAction()),
    fetchAdditionalStudentResults: () => dispatch(fetchAdditionalStudentResultsAction()),
    selectDistrictId: chosenDistrictId => {
        dispatch(fetchEnrollmentData(chosenDistrictId));
        clearState(dispatch);
        switchGrades(dispatch);
    },
    selectSchoolId: (chosenDistrictUid, chosenSchoolId) => {
        dispatch(fetchEnrollmentData(chosenDistrictUid, chosenSchoolId));
        clearState(dispatch);
        switchGrades(dispatch);
    },
    uploadPdfAvailability: pdfKey =>
        dispatch(uploadPdfAvailabilityAction(pdfKey, ReadingApplicationConfigClient)),
    selectClasseUid: (chosenDistrictUid, chosenSchoolUid, chosenClasseId, classDropDownProps) => {
        const classOrGroup =
            classDropDownProps.items.find(item => item.uid === chosenClasseId) || {};
        const burstGroupUid =
            !isEmpty(classOrGroup) && classOrGroup.burstGroup ? chosenClasseId : null;
        dispatch(
            fetchEnrollmentData(
                chosenDistrictUid,
                chosenSchoolUid,
                chosenClasseId,
                null,
                burstGroupUid,
            ),
        );
        clearState(dispatch, false);
        switchGrades(dispatch);
    },
    lrsSelectedHeaderDropdownEvent: props => {
        dispatch(selectedHeaderDropdownEvent(props));
    },
    downloadDemoPdf: (url, fileName) => dispatch(downloadDemoPdf(url, fileName)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const {
        location,
        chosenDistrictUid,
        chosenSchoolUid,
        districtDropDownProps,
        schoolDropDownProps,
        classDropDownProps,
        studentIds,
        licensingInfo,
        isPrintIconDisabled,
        selectedPeriod,
        availablePrintItems,
        hasError,
        isDemoModeOn,
        areCheckPointsFetched,
        selectedPeriodLabel,
    } = stateProps;
    const {
        selectDistrictId,
        selectSchoolId,
        selectClasseUid,
        generatePdf,
        fetchAllStudentsEnrollmentInfo,
        fetchAllTroBooksData,
        uploadPdfAvailability,
        fetchAdditionalEnrollmentData,
        fetchAdditionalStudentResults,
        lrsSelectHelpItem,
        lrsPrintCurrentPage,
    } = dispatchProps;
    const { applicationSid } = getUrlParams(location);
    const printItemsWithHandler = getPrintItemsWithHandler(
        availablePrintItems,
        (pdfConfiguration, preCallback) => generatePdf(pdfConfiguration, preCallback),
        uploadPdfAvailability,
        successfulCallback =>
            fetchAllStudentsEnrollmentInfo(studentIds, successfulCallback, applicationSid),
        fetchAdditionalEnrollmentData,
        fetchAdditionalStudentResults,
        selectedPeriodLabel,
        successfulCallback => fetchAllTroBooksData(successfulCallback),
        lrsPrintCurrentPage,
    );
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        headerLogoClassNames: getAppLogo(licensingInfo),
        headerHasErrorClassName: hasError ? 'error' : '',
        headerInDemoClassName: isDemoModeOn ? 'in-demo' : '',
        additionalURLParams: getAdditionalURLParams(location),
        topMenuItems: getTopMenuItems(
            licensingInfo,
            location,
            isPrintIconDisabled,
            buildHelpItems,
            printItemsWithHandler,
            lrsSelectHelpItem,
            isStandaloneExpress(licensingInfo) && selectedPeriod === PERIOD.SUMMARY,
        ),
        districtDropDownProps: {
            ...districtDropDownProps,
            chosenDistrictUid,
            onDropDownItemClick: chosenDistrictId => {
                selectDistrictId(chosenDistrictId);

                setLrsSelectedHeaderDropdownProps(
                    chosenDistrictId,
                    districtDropDownProps,
                    DISTRICT,
                );
            },
        },
        schoolDropDownProps: {
            ...schoolDropDownProps,
            onDropDownItemClick: chosenSchoolId => {
                selectSchoolId(chosenDistrictUid, chosenSchoolId);

                setLrsSelectedHeaderDropdownProps(chosenSchoolId, schoolDropDownProps, SCHOOL);
            },
        },
        classDropDownProps: {
            ...classDropDownProps,
            isDisabled:
                classDropDownProps.isDisabled ||
                (location?.pathname === INSTRUCTIONS_URL && !areCheckPointsFetched),
            chosenDistrictUid,
            chosenSchoolUid,
            onDropDownItemClick: chosenClasseId => {
                selectClasseUid(
                    chosenDistrictUid,
                    chosenSchoolUid,
                    chosenClasseId,
                    classDropDownProps,
                );

                setLrsSelectedHeaderDropdownProps(chosenClasseId, classDropDownProps, CLASS);
            },
        },
        getPageActiveClass: viewKey => getPageActiveClass(location, viewKey),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Header);
